/**
 * GIF Types for KLIPY API Integration
 */

// KLIPY API response types
export interface KlipyGifFormat {
  url: string
  width: number
  height: number
  size: number
}

export interface KlipyGifFile {
  hd: {
    gif: KlipyGifFormat
    webp: KlipyGifFormat
    jpg: KlipyGifFormat
    mp4: KlipyGifFormat
    webm: KlipyGifFormat
  }
  md: {
    gif: KlipyGifFormat
    webp: KlipyGifFormat
    jpg: KlipyGifFormat
    mp4: KlipyGifFormat
    webm: KlipyGifFormat
  }
  sm: {
    gif: KlipyGifFormat
    webp: KlipyGifFormat
    jpg: KlipyGifFormat
    mp4: KlipyGifFormat
    webm: KlipyGifFormat
  }
  xs: {
    gif: KlipyGifFormat
    webp: KlipyGifFormat
    jpg: KlipyGifFormat
    mp4: KlipyGifFormat
    webm: KlipyGifFormat
  }
}

export interface KlipyGif {
  id: number
  slug: string
  title: string
  file: KlipyGifFile
  tags: string[]
  type: string
  blur_preview: string
}

export interface KlipyApiResponse {
  result: boolean
  data: {
    data: KlipyGif[]
    current_page: number
    per_page: number
    has_next: boolean
  }
}

// GIF attachment for messages
export interface GifAttachment {
  id: string
  type: 'gif'
  url: string
  thumbnail_url: string
  filename: string
  mime_type: string
  klipy_id: string
  is_external: boolean
  blur_preview?: string
}

// Convert KLIPY GIF to message attachment
export function klipyGifToAttachment(gif: KlipyGif): GifAttachment {
  return {
    id: `gif-${gif.id}`,
    type: 'gif',
    url: gif.file.md.webp.url,
    thumbnail_url: gif.file.sm.webp.url,
    filename: gif.title || 'GIF',
    mime_type: 'image/webp',
    klipy_id: String(gif.id),
    is_external: true,
    blur_preview: gif.blur_preview
  }
}
